export const ListTableConst = {
  TABLE_BOTTOM_OFFSET: 32,
  LOANS_HEADER_WITHOUT_FILTERS_OFFSET: 148,
  LOANS_HEADER_WITH_FILTERS_OFFSET: 224,
};
